import React, { useState, useEffect } from "react";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import { useAuthHandling } from '../useAuthhandling';
import AdminFormPage from "../AdminFormPage";
import FieldError from "../FieldError";
import { useAppFeedback } from "../useAppFeedback";

function Serviceedit() {
  const { handleUnauthorized } = useAuthHandling();
  const { showError, showSuccess } = useAppFeedback();
  let { id } = useParams();
  const [service, setService] = useState([]);
  const [formerror, setError] = useState({});

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service/get-service/${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();

      setService(data.data);

    }
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setService({ ...service, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setService({ ...service, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.serviceName) {
      errors.serviceName = "service name is required!";
    }

    if (!values.description) {
      errors.description = "Description is required!";
    }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const ress = validate(service);
    setError(ress);
    if (!ress.serviceName && !ress.description) {
      const formData = new FormData();
      formData.append("serviceName", service.serviceName);
      formData.append("description", service.description);
      formData.append("serviceImg", service.serviceImg);
      axios
        .put(
          `${Config.apiurl}/api/v1/crm/service/update-service-info/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200 ) {
            showSuccess("Sucessfully Updated Service", {
              redirectTo: "/servicelist",
            });
          } else if(res.status === 401){
            handleUnauthorized();
          } else {
            showError("something went wrong");
          }
        });
    }
  };

  useEffect(() => {
    getinfo();
  }, []);
  return (
    <AdminFormPage title="Service Edit Table">
      <form className="forms-sample" onSubmit={PostData}>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Servicename
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="servicename"
                          name="serviceName"
                          value={service.serviceName}
                          onChange={handleInputs}
                        />
                        <FieldError message={formerror.serviceName} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Description"
                          name="description"
                          value={service.description}
                          onChange={handleInputs}
                        />
                        <FieldError message={formerror.description} />
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Image (407px * 273px)
                        </label>
                        <br></br>
                        <input
                          type="file"
                          name="serviceImg"
                          onChange={onFileChange}
                        />
                        <img src={service.serviceImg} width="200" alt="" />
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                    </form>
    </AdminFormPage>
  );
}
export default Serviceedit;
